<template>
  <v-list-item
    :dense="!item.icon"
    class="c360-navigation-drawer-expand-menu-item pl-1 pr-0 d-flex align-center charcoal--text"
    :class="[
      isActive || isHovered || isOpened ? 'c360-navigation-drawer-expand-menu-item-active' : '',
      isHovered && 'hover',
    ]"
    :disabled="item.disabled"
    @click="!item.disabled ? $emit('click') : () => null"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <v-tooltip
      v-if="!isPanelOpened"
      content-class="c360-navigation-drawer-expand-menu-item-tooltip"
      right
    >
      <template v-slot:activator="{ on, attrs }">
        <!-- TODO: move this icon into separate component.]
          disabled prop for v-tooltip doesn't work as expected.
          So we need to use v-if instead of v-tooltip's disabled prop.
        -->
        <v-sheet
          v-if="item.icon"
          v-bind="attrs"
          v-on="on"
          height="32"
          width="32"
          color="transparent"
          class="c360-navigation-drawer-expand-menu-item-icon"
        >
          <c360-icon v-if="!openOnlyByExpander && isHovered && hasChildren && !isOpened" icon="Caret_Down_MD" :size="18" />
          <c360-icon v-else-if="!openOnlyByExpander && isHovered && isOpened" icon="Caret_Up_MD" :size="18" />
          <c360-icon v-else-if="!openOnlyByExpander && isOpened" icon="Caret_Down_MD" :size="18" />
          <c360-icon v-else :icon="item.icon" :size="18" />
        </v-sheet>
      </template>
      <span>{{ item.title }}</span>
    </v-tooltip>

    <v-sheet
      v-else
      height="32"
      width="32"
      color="transparent"
      class="c360-navigation-drawer-expand-menu-item-icon"
    >
      <c360-icon v-if="isHovered && hasChildren && !isOpened" icon="Caret_Down_MD" :size="18" />
      <c360-icon v-else-if="isHovered && isOpened" icon="Caret_Up_MD" :size="18" />
      <c360-icon v-else-if="isOpened" icon="Caret_Down_MD" :size="18" />
      <c360-icon v-else :icon="item.icon" :size="18" />
    </v-sheet>

    <v-list-item-title
      class="c360-navigation-drawer-expand-menu-item-title ml-2"
      :class="[!item.icon && 'c360-text-caption font-weight-bold', item.disabled && 'disabled']"
    >
      {{ item.title }}
    </v-list-item-title>
    <v-list-item-action>
      <c360-icon v-if="hasChildren && !isOpened" icon="Caret_Down_SM" />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
  import Vue from 'vue';
  import { C360Icon } from '../Icon';

  export default Vue.extend({
    name: 'NavigationDrawerItem',

    components: { C360Icon },

    props: {
      /**
       * Grouped menu items.
       * @type {{ title: string; icon?: string; disabled: boolean; subItems?: [{title: string;}]  }}
       */
      item: {
        type: Object,
        default: () => ({}),
      },

      /**
       * Is menu item active.
       * @type {boolean}
       */
      isActive: {
        type: Boolean,
        default: false,
      },

      /**
       * Is menu opened.
       */
      isOpened: {
        type: Boolean,
        default: false,
      },

      /**
       * Is menu item has children.
       * @type {boolean}
       */
      hasChildren: {
        type: Boolean,
        default: false,
      },

      /**
       * Is panel expanded
       */
      isPanelOpened: {
        type: Boolean,
        default: false,
      },

      /**
       * Should menu be opened only by expander.
       */
       openOnlyByExpander: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        isHovered: false,
      };
    },

    methods: {
      onMouseEnter() {
        this.isHovered = true;
      },
      onMouseLeave() {
        this.isHovered = false;
      },
    },
  });
</script>

<style scoped>
  .c360-navigation-drawer-expand-menu-item-icon {
    color: var(--c360-color-charcoal);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    border-radius: 50%;
  }

  .c360-navigation-drawer-expand-menu-item-tooltip {
    background-color: #1c1c1c;
    color: #fff;
    padding: 4px 8px;
    font-weight: 600;
    font-size: 12px;
    border: none !important;
  }

  .c360-navigation-drawer-expand-menu-item-tooltip.v-tooltip__content:after,
  .c360-navigation-drawer-expand-menu-item-tooltip.v-tooltip__content:before {
    content: none;
  }

  .c360-navigation-drawer-expand-menu-item-title {
    color: var(--c360-color-charcoal);
  }

  .c360-navigation-drawer-expand-menu-item.hover {
    background: var(--c360-color-bg-light-gray);
  }

  .c360-navigation-drawer-expand-menu-item .disabled {
    color: var(--c360-color-gray);
  }

  .c360-navigation-drawer-expand-menu-item-active .c360-navigation-drawer-expand-menu-item-icon {
    background: var(--c360-gradient-accent);
    color: white;
  }

  .c360-navigation-drawer-expand-menu-item-active .c360-navigation-drawer-expand-menu-item-title {
    color: var(--c360-color-compulse) !important;
  }
</style>
